import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Mi jefe puede saber que uso IA?',
    a: 'No, porque tú eres el filtro final. La IA hace el borrador perfecto, tú le das el toque humano.'
  }, {
    q: '¿Sirve para cualquier cargo?',
    a: 'Si usas un ordenador para enviar correos o analizar información, te sirve.'
  }, {
    q: '¿Necesito la versión de pago de ChatGPT?',
    a: 'Funciona con versiones gratuitas, aunque las versiones Pro (ChatGPT o Claude) son un 300% más rápidas.'
  }, {
    q: '¿Es difícil de implementar?',
    a: 'Si sabes copiar y pegar texto, ya tienes el 90% del conocimiento necesario.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-[#0d1322] border-t border-slate-800/50" data-id="element-11">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <FadeIn data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12" data-id="element-14">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-15">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-16">
              <div className="bg-[#111827] border border-slate-800 rounded-xl overflow-hidden" data-id="element-17">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-18">
                  <span className="text-lg font-semibold text-white" data-id="element-19">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-cyan-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-20" />
                </button>
                <AnimatePresence data-id="element-21">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-22">
                      <div className="px-6 pb-5 text-[#d1d5db] leading-relaxed" data-id="element-23">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}